import cn from "classnames";
import { useState } from "react";
import { Accordion, Button, Col, Container, Row } from "react-bootstrap";
import { Chart } from "react-google-charts";

import classes from "./styles.module.scss";

export default function ({ className = "my-4 bg-light p-4", title, groups, items, EditableText }) {
  const [active, setActive] = useState(items.find((i) => i.group === groups[0].id));

  return (
    <Container>
      <div className={cn(className, classes.StatisticsPieChart)}>
        <EditableText path="title" tag="h4" className="mb-5">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <Row>
          <Col xs={12} md={6}>
            <Chart
              className="chart"
              chartType="PieChart"
              title={null}
              width="100%"
              height={500}
              options={{
                backgroundColor: "transparent",
                sliceVisibilityThreshold: 0,
                animation: {
                  duration: 500,
                  easing: "out",
                },
                fontSize: 18,
                legend: {
                  position: "bottom",
                  alignment: "center",
                  textStyle: {
                    fontSize: 18,
                    color: "black",
                  },
                },
                colors: ["#2E4386", "#B63434", "#72747A"],
              }}
              data={active?.data ?? []}
            />
          </Col>
          <Col xs={12} md={6}>
            <Accordion defaultActiveKey={groups[0].id}>
              {groups.map(({ id, title }) => (
                <Accordion.Item key={id} eventKey={id}>
                  <Accordion.Header>{title}</Accordion.Header>
                  <Accordion.Body>
                    {items
                      .filter((i) => i.group === id)
                      .map((item, idx) => (
                        <div key={idx} className="mb-2">
                          <Button
                            onClick={() => setActive(item)}
                            variant="outline-blue"
                            active={item === active}
                          >
                            {item.name}
                          </Button>
                        </div>
                      ))}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
